class ColorSchemeWidget {
    selectors = {
        item: '.js-color-scheme-set',
        button: '.js-color-scheme-toggle',
        active_icon: '.js-color-scheme-icon'
    }
    constructor($el, options) {
        const that = this;

        // DOM
        that.$wrapper = $el;
        that.$active_icon = that.$wrapper.find(that.selectors.active_icon);

        // CONST
        that.schemes = options['schemes'];
        that.templates = options['templates'];

        // VARS
        that.active_scheme = $.sa.color_scheme_manager.getScheme();
        that.$active_item = null;

        // INIT
        that.#init();

        that.$wrapper.data('color-scheme-widget', that);
    }

    #init() {
        const that = this;

        // Инициируем активный вариант
        const $active_item = that.$wrapper.find(that.selectors.item + '[data-scheme='+that.active_scheme+']');
        if ($active_item.length) {
            that.#setItem($active_item.first());
        }

        // Клик по кнопке (открываем дровер для не-десктопов)
        that.$wrapper.on('click', that.selectors.button, function(event) {
            event.preventDefault();
            if (!$.sa.is_desktop()) {
                that.#showDrawer();
            }
        });

        // Клик по варианту
        that.$wrapper.on('click', that.selectors.item, function(event) {
            event.preventDefault();
            that.#setItem($(this));
        });
    }

    #setItem($item) {
        const that = this;
        const scheme = $item.data('scheme');

        that.active_scheme = scheme;
        $.sa.color_scheme_manager.setScheme(scheme);
        UIDropdown.prototype.hideCurrent(that.$wrapper);

        setActiveItem($item);
        setActiveIcon(scheme);

        /**
         * @param {jQuery} $item
         * */
        function setActiveItem($item) {
            const active_class = 'current';

            // Active in list 
            if (that.$active_item) {
                that.$active_item.removeClass(active_class);
            }
            that.$active_item = $item.addClass(active_class);
        }

        /**
         * @param {String} scheme
         * */
        function setActiveIcon(scheme) {
            const is_dark = $.sa.color_scheme_manager.isDark(scheme),
                  scheme_id = (is_dark ? ColorSchemeManager.SCHEMES.dark : ColorSchemeManager.SCHEMES.light);

            const scheme_data = that.schemes[scheme_id],
                  $icon = $(that.templates.icon).addClass(scheme_data.icon);

            that.$active_icon.html("").append($icon);
        }
    }

    #showDrawer() {
        const that = this;

        const $content = that.$wrapper.find('.js-color-scheme-menu-content').clone(),
              $header = $content.find('.js-color-scheme-menu-header'),
              header = $header.html();

        $header.remove();

        $.uiDrawerBottom({
            header_contrast: true,
            header: header,
            content: $content,
            onOpen($wrapper, drawer) {
                // Класс для стилей
                $wrapper.addClass('ui-color-scheme-drawer');

                // Клик по элементу в дровере
                $wrapper.on('click', that.selectors.item, function(event) {
                    event.preventDefault();
                    setItem($(this));
                });

                /**
                 * @param {jQuery} $item
                 * */
                function setItem($item) {
                    const item_scheme = $item.data('scheme');

                    const $item_search = that.$wrapper.find(that.selectors.item + '[data-scheme='+item_scheme+']');
                    if ($item_search.length) {
                        that.#setItem($item_search.first());
                    }

                    drawer.close();
                }
            },
            onBgClick: function (uiDrawerBottom) {
                uiDrawerBottom.close();
            }
        });
    }
}